'use client';

import { useState, useEffect } from 'react';
import Icon from "@/components/ui/AppIcon";
import { createClient } from '@/lib/supabase/client';

interface WeatherAlert {
  id: string;
  title: string;
  description: string;
}

const DEMO_ALERT: WeatherAlert | null = null;

export default function WeatherAlertBanner() {
  const [alert, setAlert] = useState<WeatherAlert | null>(DEMO_ALERT);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const supabase = createClient();
    async function fetchWeatherAlert() {
      try {
        const { data } = await supabase
          .from('escalations')
          .select('id, title, description')
          .ilike('title', '%weather%')
          .neq('status', 'resolved')
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();
        if (data) setAlert(data);
        // else keep DEMO_ALERT
      } catch {
        // keep DEMO_ALERT
      }
    }
    fetchWeatherAlert();
  }, []);

  if (!alert || dismissed) return null;

  return (
    <div className="flex items-center gap-3 bg-warning/10 border border-warning/30 rounded-xl px-5 py-3 mb-6">
      <div className="w-8 h-8 rounded-lg bg-warning/20 flex items-center justify-center flex-shrink-0">
        <Icon name="CloudIcon" size={18} className="text-warning" variant="solid" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-body text-sm font-medium text-warning">
          {alert.title}
        </p>
        <p className="font-caption text-xs text-warning/80 line-clamp-1">
          {alert.description}
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={() => setDismissed(true)}
          className="flex items-center justify-center text-warning/60 hover:text-warning transition-standard rounded-md hover:bg-warning/10"
          style={{ minWidth: '44px', minHeight: '44px' }}
          aria-label="Dismiss alert"
        >
          <Icon name="XMarkIcon" size={16} />
        </button>
      </div>
    </div>
  );
}